import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedCollections from './components/FeaturedCollections';
import HotWorksGrid from './components/HotWorksGrid';
import ReaderReviews from './components/ReaderReviews';
import CtaSection from './components/CtaSection';

const ldJson = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "韩国漫画网-好看的韩国漫画_韩漫在线免费阅读_韩漫大全",
  "description": "好看韩国漫画,韩漫在线免费阅读,韩漫大全,热门作品,精选合集",
  "url": "http://szshops.com/",
  "inLanguage": "zh-CN",
  "isPartOf": {
    "@type": "WebSite",
    "name": "韩漫大全",
    "url": "http://szshops.com/"
  },
  "breadcrumb": {
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "首页", "item": "http://szshops.com/" }
    ]
  }
};

export default function Home() {
  return (
    <>
      <title>韩国漫画网-好看的韩国漫画_韩漫在线免费阅读_韩漫大全</title>
      <meta name="description" content="好看韩国漫画,韩漫在线免费阅读,韩漫大全,热门作品,精选合集。本站汇聚了众多好看的韩国漫画，支持韩漫在线免费阅读，大全内容涵盖各种热门与精选作品，满足您的一切阅读期待。" />
      <meta name="keywords" content="韩国漫画, 韩漫在线免费阅读, 韩漫大全, 热门作品, 精选合集" />
      <link rel="canonical" href="http://szshops.com/" />
      <meta property="og:title" content="韩国漫画网-好看的韩国漫画_韩漫在线免费阅读_韩漫大全" />
      <meta property="og:description" content="好看韩国漫画,韩漫在线免费阅读,韩漫大全,热门作品,精选合集" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="http://szshops.com/" />
      <script type="application/ld+json">{JSON.stringify(ldJson)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <article>
            <HeroSection />
            <FeaturedCollections />
            <HotWorksGrid />
            <ReaderReviews />
            <CtaSection />
          </article>
        </main>
        <Footer />
      </div>
    </>
  );
}